import { React, useState } from "react";

// material ui imports

import {
  Box,
  Typography,
  Modal,
  Paper,
  useTheme,
  TextField,
  InputAdornment,
  Button,
  MenuItem,
} from "@mui/material";
import { Formik, Form } from "formik";

// import Icons

import { LimospayTextIcon } from "../../Svg";
// import { bgcolor } from "@mui/system";

//  Form Validation

// import { ModalValidation } from "../../Services/validation/modalValidation";

const style = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  height: "85vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
  verticalAlign: "middle",
};

const FormModal = ({
  open,
  onClose,
  modalPages,
  MainHeading,
  SecondMainHeading,
  SubHeading,
  SimpleText,
  SecondSimpleText,
  TextFieldArray,
  TextFieldArraySecond,
  ButtonsArray,
  ButtonsArraySecond,
  initialFormData = {},
  onSubmit,
  BackIcon,
  ModalLoaderText,
  ModalFinalSuccessState,
  ModalFinalSuccessIcon,
  ResourceStatus,
  SuccessButtonsList,
  afterSuccessFirstMessage,
  afterSuccessSecondMessage,
  cards = [],
  ValidationSchemaModals,
}) => {
  // theme

  const theme = useTheme();

  // state

  const [modalFirstPageDataNumber, setModalFirstPageDataNumber] = useState(1);
  const [afterSuccessofModal, setAfterSuccessofModal] = useState(false);
  const [formData, setFormData] = useState({});

  // Initial Values

  const initialValues = TextFieldArray.reduce(
    (prevValue, row, index, arrayOfTextField) => {
      const obj = { [row?.name]: row?.value || "" };
      return { ...obj, ...(prevValue || {}) };
    },
    {}
  );

  // Form Data

  const addFormData = (fieldsArray, values) => {
    const data = fieldsArray.reduce((result, row, index, arrayOfTextField) => {
      const obj = { [row?.name]: values?.[row?.name] };
      result = result || {};

      if (row?.formKey) {
        result[row?.formKey] = {
          ...(result?.[row?.formKey] || {}),
          ...obj,
        };
        return result;
      } else {
        return { ...obj, ...(result || {}) };
      }
    }, initialFormData);
    setFormData({ ...formData, ...data });
  };

  const handleFormSubmit = () => {
    onSubmit(formData);
  };
  // change state method

  const changeModalState = (ButtonText) => {
    TextFieldArray.map((row, index) => {
      if (ButtonText === "Next" && modalPages === 2) {
        setModalFirstPageDataNumber(2);
      }
    });

    if (ButtonText === "Back") {
      onClose();
    }
  };

  const changeModalState2 = (ButtonText) => {
    if (ButtonText === "Back" && modalPages === 2 && modalFirstPageDataNumber) {
      setModalFirstPageDataNumber(1);
    }
    if (ButtonText === "Confirm") {
      setAfterSuccessofModal(true);
    }
    // console.log("Button State == " + afterSuccessofModal);
  };

  const submitHandler = (
    e,
    row,
    fieldsArray = [],
    touched,
    errors,
    setFieldTouched
  ) => {
    if (row?.text === "back") {
      setModalFirstPageDataNumber(modalFirstPageDataNumber--);
    } else {
      let upcomingErrors = [];
      let fieldsTouched = [];
      fieldsArray?.forEach((field, index, array) => {
        setFieldTouched(field?.name, true, true);
        const field_touched = touched?.[field?.name];
        const field_errors = errors?.[field?.name];
        if (field_errors) {
          upcomingErrors.push(field_errors);
        }
        if (field_touched) {
          fieldsTouched.push(field_touched);
        }
      });
      if (!(upcomingErrors.length > 0)) {
      }
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <>
          {/* {afterSuccessofModal === false && ( */}
          <Paper
            elevation={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              width: { xs: "80%", md: "50%", lg: "30%" },
              padding: 1,
              minHeight: "85vh",
              borderRadius: 1,
              borderTop: `5px solid  ${theme.palette.primary.main}`,
            }}
          >
            <Box
              width="80%"
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              margin="auto"

              // justifyContent={"center"}
            >
              {BackIcon && (
                <Box sx={{ width: "70%", position: "absolute" }} mt={1} mr={8}>
                  <Button onClick={() => onClose()}>
                    <BackIcon />
                  </Button>
                </Box>
              )}
              <Box mt={2}>
                <LimospayTextIcon />
              </Box>
              {modalFirstPageDataNumber === 1 && (
                <Box>
                  <Box>
                    <Typography paddingY={1} variant="h6">
                      {MainHeading}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography paddingY={1} variant="p">
                      {SubHeading}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography paddingY={1} variant="subtitle2">
                      {SimpleText}
                    </Typography>
                  </Box>
                </Box>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={ValidationSchemaModals}
                onSubmit={handleFormSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleSubmit,
                  setFieldTouched,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    {modalFirstPageDataNumber === 1 && (
                      <>
                        <Box>
                          {TextFieldArray?.map((row, index) => (
                            <TextField
                              fullWidth
                              key={`${row?.name}-${index + 2}`}
                              label={row?.label}
                              name={row?.name}
                              type={row?.type}
                              value={values?.[row?.name]}
                              variant="standard"
                              onChange={handleChange}
                              size="small"
                              select={row?.type === "select"}
                              disabled={row?.disable}
                              error={
                                touched?.[row?.name] &&
                                Boolean(errors?.[row?.name])
                              }
                              helperText={
                                touched?.[row?.name] && errors?.[row?.name]
                              }
                              sx={{
                                paddingY: 1,
                                fontSize: 4,
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment
                                    sx={{ marginBottom: 1 }}
                                    position="end"
                                  >
                                    {row?.icon}
                                  </InputAdornment>
                                ),
                              }}
                            >
                              {row?.options?.map((option) => (
                                <MenuItem value={option?.value}>
                                  {option?.name}
                                </MenuItem>
                              ))}
                              {/* <MenuItem value={row?.menu2}>
                                {row?.menu2}
                              </MenuItem>
                              <MenuItem value={row?.menu3}>
                                {row?.menu3}
                              </MenuItem> */}
                            </TextField>
                          ))}
                        </Box>
                        <Box>
                          <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"space-around"}
                            mt={3}
                            gap={3}
                          >
                            {ButtonsArray?.map((row, index) => {
                              return (
                                <Button
                                  type={row?.type || "button"}
                                  onClick={(e) => {
                                    if (row?.text === "Back") {
                                      onClose();
                                    } else if (modalPages > 1) {
                                      let upcomingErrors = [];
                                      let fieldsTouched = [];
                                      TextFieldArray?.forEach(
                                        (field, index, array) => {
                                          setFieldTouched(
                                            field?.name,
                                            true,
                                            true
                                          );
                                          const field_touched =
                                            touched?.[field?.name];
                                          const field_errors =
                                            errors?.[field?.name];
                                          if (field_errors) {
                                            upcomingErrors.push(field_errors);
                                          }
                                          if (field_touched) {
                                            fieldsTouched.push(field_touched);
                                          }
                                          if (
                                            !upcomingErrors.length &&
                                            fieldsTouched.length ===
                                              array.length
                                          ) {
                                            addFormData(TextFieldArray, values);
                                            setModalFirstPageDataNumber(2);
                                          }
                                        }
                                      );
                                    } else if (row?.type === "submit") {
                                      addFormData(TextFieldArray, values);
                                      submitHandler(
                                        e,
                                        row,
                                        TextFieldArray,
                                        touched,
                                        errors,
                                        setFieldTouched
                                      );
                                    }
                                  }}
                                  key={`${row?.text}`}
                                  variant="contained"
                                  sx={{
                                    marginTop: 1,
                                    height: theme.spacing(5),
                                    paddingY: 1,
                                    minWidth: row?.width,
                                    backgroundColor: row?.bgcolor,
                                  }}
                                >
                                  {row?.text}
                                </Button>
                              );
                            })}
                          </Box>
                        </Box>
                      </>
                    )}
                    {modalFirstPageDataNumber === 2 && (
                      <>
                        <Box
                          display={"flex"}
                          flexDirection={"column"}
                          alignItems={"center"}
                        >
                          <Typography paddingY={1} variant="h6">
                            {SecondMainHeading}
                          </Typography>
                        </Box>

                        <Box
                          display={"flex"}
                          flexDirection={"column"}
                          alignItems={"center"}
                        >
                          <Typography paddingY={1} variant="subtitle2">
                            {SecondSimpleText}
                          </Typography>
                        </Box>
                        <Box>
                          {TextFieldArraySecond?.map((row, index) => (
                            <TextField
                              fullWidth
                              key={`${row?.name} - ${index + 1}`}
                              label={row?.label}
                              name={row?.name}
                              type={row?.type}
                              value={values?.[row?.name] || ""}
                              variant="standard"
                              onChange={handleChange}
                              sx={{
                                paddingY: 1,
                                fontSize: 4,
                              }}
                              error={
                                touched?.[row?.name] &&
                                Boolean(errors?.[row?.name])
                              }
                              helperText={
                                touched?.[row?.name] && errors?.[row?.name]
                              }
                            ></TextField>
                          ))}
                        </Box>
                        <Box>
                          <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"space-around"}
                            mt={3}
                            gap={3}
                          >
                            {ButtonsArraySecond?.map((row, index) => {
                              return (
                                <Button
                                  onClick={(e) => {
                                    if (row?.type === "submit") {
                                      addFormData(TextFieldArraySecond, values);
                                      submitHandler(
                                        e,
                                        row,
                                        TextFieldArraySecond,
                                        touched,
                                        errors,
                                        setFieldTouched
                                      );
                                    } else {
                                      changeModalState2(row?.text, row);
                                    }
                                  }}
                                  type={row?.type || "button"}
                                  key={`${row?.text} -${index}`}
                                  variant="contained"
                                  sx={{
                                    marginTop: 1,
                                    height: theme.spacing(5),
                                    paddingY: 1,
                                    minWidth: row?.width,
                                    backgroundColor: row?.bgcolor,
                                  }}
                                >
                                  {row?.text}
                                </Button>
                              );
                            })}
                          </Box>
                        </Box>
                      </>
                    )}
                  </Form>
                )}
              </Formik>
            </Box>
          </Paper>

          {/* 
          {afterSuccessofModal === true && (
            <Typography>djbsbcbhsdjcbvjhsdvdmhvjhs</Typography>
          )} */}
        </>
      </Modal>
    </>
  );
};

export default FormModal;
